/* eslint-disable */

import PARSE from "html-react-parser";
import Moment from "moment";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { Skeleton } from "@mui/material";
import GlobalApi from "../../context/api/GlobalApi";
import Api from "./Api";
import { Link } from "react-router-dom";
import BlogPostSEO from "./BlogPostSEO";

function SSoft_Blog_Detail() {
  const currentPath = window.location.href;
  const [article, setArticle] = useState(null);
  const [articleContent, setArticleContent] = useState(null);
  const [sections, setSections] = useState([]);
  const [isFetching, setIsFetching] = useState(true);

  const paramID = useParams();
  const navigate = useNavigate();
  const activeLang = useSelector((state) => state.content.activeLanguage);
  const videoEl = useRef(null);

  const getSectionsDetail = useCallback(() => {
    const api = new Api();
    api
      .getSectionDetail({ language: activeLang })
      .then((res) => {
        if (res.status === 200 && res.data.results) {
          setSections(res.data.results || []);
        }
      })
      .catch((err) => {
        console.error("getSectionsDetail err", err);
      });
  }, [activeLang]);

  useEffect(() => {
    getSectionsDetail();
  }, [getSectionsDetail]);

  const getDetailArticle = useCallback(() => {
    const api = new GlobalApi();
    api
      .getArticleDetailNew({ id: paramID.param1, all_languages: "False" })
      .then((res) => {
        setArticle(res.data || null);
        setArticleContent(res.data?.article_languages || null);
        setIsFetching(false);
      })
      .catch((err) => {
        console.error("getDetailArticle err", err);
        setIsFetching(false);
      });
  }, [paramID.param1]);

  useEffect(() => {
    // keep behavior: refetch when activeLang changes if you want that
    getDetailArticle();
  }, [activeLang, getDetailArticle]);

  // derive text & hero image from sections without causing re-renders
  const { derivedText, derivedHero, derivedLink } = useMemo(() => {
    let textArr = [];
    let hero = null;
    let linkBlog = null;
    const sec = sections[0]?.widgets || [];
    sec.forEach((section, i) => {
      switch (i) {
        case 0:
          const textData = section.widget_contents;
          if (textData && textData.length > 0) {
            textArr = textData;
          }
          break;
        case 1:
          // don't call setState here; just set local var
          hero = section.widget_contents?.[0] ?? null;
          break;
        case 2:
          // don't call setState here; just set local var
          linkBlog = section.widget_contents?.[0] ?? null;
          break;
        default:
          break;
      }
    });

    return { derivedText: textArr, derivedHero: hero, derivedLink: linkBlog };
  }, [sections]);

  const fliterLangKey = useMemo(() => {
    return article?.article_keywords?.filter(
      (key) => key?.language?.id === activeLang
    );
  }, [article, activeLang]);

  if (isFetching) {
    return (
      <div className="h-full max-w-[1000px] mx-auto mt-[80px] px-8">
        <div className="">
          <h1 className="font-inter-bold text-[28px]">
            <Skeleton />
          </h1>
          <Skeleton />
          {articleContent?.path && (
            <div className="mt-[15px]  ">
              <Skeleton />
            </div>
          )}
        </div>
        <div className="mt-[45px]">
          <Skeleton variant="rect" width="100%" height={350} />
        </div>
        <div className="typo-style">
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </div>
      </div>
    );
  }

  // final render guard
  if (!isFetching && (!sections || sections.length === 0 || !article)) {
    return !isFetching && !article ? "" : null;
  }

  return (
    <>
      {articleContent?.title && (
        // <Helmet>
        //   <meta name="description" content={articleContent.description || ""} />
        //   <meta
        //     name="keywords"
        //     content={
        //       fliterLangKey
        //         ? fliterLangKey
        //             .map((k) => k?.keyword?.name)
        //             .filter(Boolean)
        //             .join(", ")
        //         : ""
        //     }
        //   />
        //   <title>{articleContent.title}</title>
        //   <link rel="canonical" href={currentPath} />
        // </Helmet>
        <BlogPostSEO
          title={articleContent?.title}
          description={articleContent?.description}
          slug={articleContent?.slug_title}
          aio={article?.aio_description}
        />
      )}

      <div className="section-container section-margin-x py-[90px] mt-[78px]">
        <div className="relative z-[-1] bg-[#1a2bs35] rounded-[20px] xl:pb-[40px] mdl:pb-[160px] pb-[120px] px-[40px] pt-[40px] mdl:p-[60px] h-[400px] flex items-center">
          <div
            className="absolute inset-0 rounded-[20px] z-[-1] bg-cover bg-center w-full"
            style={{
              backgroundImage: `url(${derivedHero?.file_medium})`,
            }}
          />
          <div className="space-y-[16px]">
            <p className="content-header-style-non-hero !text-white">
              {derivedText?.[0]?.content ?? ""}
            </p>

            <h1 className="text-white header-style-hero">
              {articleContent?.title}
            </h1>

            <div className="flex flex-wrap space-x-1 !mt-4">
              {article?.categories?.map((cat) => (
                <p
                  key={cat?.id}
                  className="text-xs font-inter h-fit rounded bg-cuzRed text-white px-2 py-1 w-fit"
                >
                  {cat?.name}
                </p>
              ))}
            </div>
          </div>
        </div>

        <div className="h-full max-w-[800px] mx-auto mt-[80px] ">
          <div>
            {articleContent?.path && (
              <div className="mt-[15px]  ">
                <div className="inline-flex font-inter-bold">{`${
                  derivedText?.[0]?.content ?? ""
                } : `}</div>
                <a
                  href={articleContent?.path}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {` ${articleContent?.path}`}
                </a>
              </div>
            )}
          </div>

          {/* <div className="mt-[45px]">
            <div className="space-y-2 flex items-center " />
          </div> */}

          <div className="content-subheader-style-non-hero mt-[45px] prose prose-lg">
            <p className="!font-inter-bold mb-[40px]">
              {article && Moment(article.date).format("DD MMMM YYYY")}
            </p>{" "}
            <div className="content-subheader-style-non-hero prose">
              {articleContent?.content && PARSE(articleContent?.content)}
            </div>
          </div>

          {article?.article_assets?.length > 1 && (
            <video
              style={{
                backgroundColor: "black",
                maxWidth: "100%",
                maxHeight: "100%",
                width: "100%",
                height: "550px",
              }}
              controls
              alt="All the devices"
              ref={videoEl}
            >
              <source
                src={article?.article_assets?.[1]?.asset?.asset_file}
                type="video/mp4"
              />
            </video>
          )}
          <p className="text-xs invisible">
            {derivedLink?.article_language?.summary}
          </p>
          <button
            type="button"
            className="  mt-[70px]  all-button bg-[#255262] cursor-pointer !w-fit"
            // onClick={() => navigate(-1)}
          >
            <Link to={derivedLink?.article_language?.path} className="w-fit">
              {derivedText?.[1]?.content ?? "Back"}
            </Link>
          </button>
        </div>
      </div>
    </>
  );
}

export default SSoft_Blog_Detail;
